import apiClient from '../client';
const ENDPOINT = '/schedule-lessons';

export const lessonsApi = {
    getList: ({ page = 1, pageSize = 10, sortBy = '-id', filter = {} }) =>
        apiClient.get(ENDPOINT, { params: { page, pageSize, sortBy, filter } }),
    getDetail: (id) => apiClient.get(`${ENDPOINT}/${id}`),
    create: (payload) => apiClient.post(ENDPOINT, payload),
    update: (payload) => apiClient.put(`${ENDPOINT}/${payload.id}`, payload),
    delete: (id) => apiClient.delete(`${ENDPOINT}/${id}`),
    joinMeeting: (payload) =>
        apiClient.post(`${ENDPOINT}/${payload.id}/start`, {
            studentId: payload?.studentId
        })
};
